<template>
  <b-form class="gym-form">
    <b-form-group label="Название спортзала">
      <b-form-input
        v-model="value.name"
        type="text"
        placeholder="Введите название спортзала"
      />
    </b-form-group>
    <b-form-group label="Выбор добавляющих">
      <item-picker
        :fields="userPickerTableFields"
        :items="activeUsers"
        v-model="adders"
        class="gym-form__adder-picker"
        picked-title="Добавляющие"
        unpicked-title="Пользователи"
      />
    </b-form-group>
    <b-form-group label="Выбор менеджеров">
      <item-picker
        :fields="userPickerTableFields"
        :items="activeUsers"
        v-model="managers"
        class="gym-form__manager-picker"
        picked-title="Менеджеры"
        unpicked-title="Пользователи"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import GymModel from "@/components/Forms/Gym/models/gymModel";
import ItemPicker from "@/components/Forms/ItemPicker";
import AdderModel from "@/components/Forms/Gym/models/adderModel";
import ManagerModel from "@/components/Forms/Gym/models/managerModel";
import { mapGetters } from "vuex";

let userPickerTableFields = [
  {
    key: "name",
    label: "Имя",
    search: true,
    formatter: (value, key, item) => {
      let { roles } = item;
      let rolesStr = roles
        .map(({ display_name: displayName }) => displayName)
        .join(", ");
      if (rolesStr.length > 0) rolesStr = ` (${rolesStr})`;
      return `${value}${rolesStr}`;
    }
  }
];

export default {
  components: { ItemPicker },
  props: {
    value: {
      type: GymModel,
      required: false,
      default: () => new GymModel()
    }
  },
  data() {
    return {
      userPickerTableFields
    };
  },
  computed: {
    ...mapGetters("users", ["users"]),
    activeUsers: ({ users }) =>
      users.filter(({ is_deleted: isDeleted }) => !Number(isDeleted)),
    adders: {
      get: ({ value, activeUsers }) =>
        activeUsers.filter(user =>
          value.adders.map(adder => adder.id).includes(user.id)
        ),
      set: function(pickedUsers) {
        this.value.adders = pickedUsers.map(user => new AdderModel(user));
      }
    },
    managers: {
      get: ({ value, activeUsers }) =>
        activeUsers.filter(user =>
          value.managers.map(adder => adder.id).includes(user.id)
        ),
      set: function(pickedUsers) {
        this.value.managers = pickedUsers.map(user => new ManagerModel(user));
      }
    }
  }
};
</script>

<style lang="scss">
.gym-form {
  &__price-editor {
    display: flex;
    border-radius: 0.25rem;
    border: solid 1px #ced4da;
    margin-bottom: 5px;
    .price-editor {
      margin-bottom: 0;
      flex-grow: 1;
      &__name,
      &__value {
        border: 0;
      }
      &__value {
        border-top: solid 1px #ced4da;
        border-top-left-radius: 0;
      }
      &__name {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin-bottom: 3px;
      }
    }
    &__remove-button {
      margin: -1px;
      border-radius: 0.25rem;
    }
  }
}
</style>
